










































































import { Component, Prop, Vue } from 'vue-property-decorator';
import NewsComment from './NewsComment.vue';
import NewsArticleSubmitComment from './NewsArticleSubmitComment.vue';
import Reactions from '@/components/frontpage/reactions/Reactions.vue';
import { NewsModule } from '@/store/modules/news/news.store';
import { NewsViewObject, NewsReactionRequest, ReactionType } from '@/types/apiServerContract';

@Component({
    components: {
        NewsComment,
        NewsArticleSubmitComment,
        Reactions
    }
})
export default class NewsArticle extends Vue {
	@Prop({ required: true }) news!: NewsViewObject;
	@Prop({ type: Boolean, default: false }) active!: boolean;
	@Prop({ type: Boolean }) isLoggedIn!: boolean;
	@Prop({ type: Boolean, default: false }) incomplete!: boolean;

	expanded: boolean = this.active;
	showComments: boolean = false;
	loading: boolean = false;
	commentsLoading: boolean = false;

	async getNewsData() {
	    if (this.loading || this.incomplete) return;

	    this.loading = true;

	    try {
	        await NewsModule.GetNewsData({ newsId: this.news.id });
	    } finally {
	        this.loading = false;
	    }
	}

	async toggleNews(state: boolean) {
	    if (state) this.getNewsData();
	    this.expanded = state;
	    this.showComments = false;
	}

	async toggleComments() {
	    if (this.commentsLoading || this.incomplete) return;

	    if (!this.showComments) {
	        this.commentsLoading = true;

	        try {
	            await NewsModule.GetComments({ newsId: this.news.id });
	        } finally {
	            this.commentsLoading = false;
	        }
	    }

	    this.showComments = !this.showComments;
	}

	setFixedHeight(el: HTMLElement) {
	    el.style.height = el.scrollHeight + 'px';
	    el.style.overflow = 'hidden';
	}

	setAutoHeight(el: HTMLElement) {
	    el.style.height = 'auto';
	    el.style.overflow = 'visible';
	}

	async reacted(data: { type: ReactionType; active: boolean }) {
	    const request: NewsReactionRequest = {
	        type: data.type,
	        newsId: this.news.id,
	        active: data.active
	    };

	    await NewsModule.NewsReaction(request);
	}

	mounted() {
	    if (this.active) {
	        NewsModule.GetNewsData({ newsId: this.news.id });
	    }
	}
}
